
//------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated from a template (Model.tst).
//
//     Manual changes to this file may cause unexpected behavior in your application.
//     Manual changes to this file will be overwritten if the code is regenerated.
// </auto-generated>
//------------------------------------------------------------------------------

import { DomainRegistrantInfoModel } from './Distribution.Api.Models.DomainRegistrantInfo';
import { Model, ModelProperty } from 'models/Model';


export class AddDomainRequestModel extends Model<AddDomainRequestModel> {
	public static classProperties: ModelProperty[] = [
		
		{ name: 'domainId', type: 'string' },
		{ name: 'action', type: 'DomainAction' },
		{ name: 'name', type: 'string' },
		{ name: 'companyId', type: 'string' },
		{ name: 'productPlanId', type: 'string' },
		{ name: 'registrantInfo', type: 'DomainRegistrantInfoModel', isHidden: true, isObject: true, new: () => { return new DomainRegistrantInfoModel }, properties: () => { return DomainRegistrantInfoModel.classProperties } }
	];
	[key: string]: any;
	
	public domainId?: string;
	public action: DomainAction;
	public name: string;
	public companyId?: string;
	public productPlanId?: string;
	public registrantInfo?: DomainRegistrantInfoModel;
    
	constructor(){
		super();
		this.domainId = undefined;
		this.action = 0;
		this.name = '';
		this.companyId = undefined;
		this.productPlanId = undefined;
		this.registrantInfo = undefined;
		
	}
	getProperties(){
		return AddDomainRequestModel.classProperties;
	}
}

export enum DomainAction{
	Nothing = 0,
	Buy = 1,
	TransferNameServer = 2,
	TransferToRegistrar = 3,
	AddDomainForDns = 4,
	RedelegateToRegistrar = 5
}
export namespace DomainAction {
	export function getKeys(): Map<DomainAction, string> {
		return new Map([[0, 'Nothing'], [1, 'Buy'], [2, 'TransferNameServer'], [3, 'TransferToRegistrar'], [4, 'AddDomainForDns'], [5, 'RedelegateToRegistrar']]);
	}
}
